<template>
    <div>   
        <v-divider></v-divider>
        <!-- <mbs-page-tab 
            :items="MY_LINKS"/>  -->
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-container grid-list-xl> 
            <v-layout class="mt-1" align-center="" justify-center="">
                <v-col sm="12" cols="12"> 
                    <v-card > 
                        <div v-if="PAGE_CURRENT!=null"> 
                            <mbs-page-tab 
                                v-model="PAGE_CURRENT"
                                :items="PageTabs"/> 
                        </div>
                        <mbs-item-manager
                            :table_title="PageInfo.title"
                            :table_title_icon="PageInfo.icon"
                            :add_vertical_lines="true"
                            :row_click="true"
                            :table_tabs="TableTabs"
                            :top_label="false"
                            :filter_date="true"
                            :filter_date_value="'created_at'"
                            :filter_default_days="'90'"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM" 
                            :header_items="HEADER_ITEMS"
                            :header_items2="HEADER_ITEMS2"
                            :data_items="TabData"   
                            :is_joined="true"
                            :path_item="SOCK_ORDER_PATH"   


                            :table_actions="TableActions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                        />
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  
        <div>
            
        </div>

        <mbs-stock-inventory 
            :to_outlet_code="null"
            :from_outlet_code="null"
           /> 
    </div> 
</template>

<script>
    import DATA from '../../../plugins/DATA'
    import { mdiInvoiceCheckOutline } from '@mdi/js';
    import { mdiInvoiceCheck } from '@mdi/js';
    import { mdiInvoiceTextPlusOutline } from '@mdi/js';
    import {mapState} from "vuex"
    let PAGE_NAME = DATA.ITEMS.STOCK_ORDERS.values    
    export default {
        name:PAGE_NAME, 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:0,
                PAGE_SIZE:10,
                mdiInvoiceCheckOutline,mdiInvoiceCheck,
                NAME_ITEMS:DATA.ITEMS.STOCK_ORDERS.names,
                NAME_ITEM:DATA.ITEMS.ORDERS.name,
                VALUE_ITEMS:DATA.ITEMS.STOCK_ORDERS.values,
                VALUE_ITEM:DATA.ITEMS.STOCK_ORDERS.value,    
                show_old_stock_order:false
                
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                })
                this.FEEDBACKS(1000) 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                StockOrders: state=> state.items[(DATA.ITEMS.STOCK_ORDERS.values).toUpperCase()],
                JoinedStockOrders: state=> state.join[(DATA.ITEMS.STOCK_ORDERS.values).toUpperCase()], 
                OldStockOrders: state=> state.items[(DATA.ITEMS.OLD_STOCK_ORDERS.values).toUpperCase()],
                JoinedOldStockOrders: state=> state.join[(DATA.ITEMS.OLD_STOCK_ORDERS.values).toUpperCase()], 
                StockRequests: state=> state.items[(DATA.ITEMS.STOCK_REQUESTS.values).toUpperCase()],
                JoinedStockRequests: state=> state.join[(DATA.ITEMS.STOCK_REQUESTS.values).toUpperCase()],
                StockDrafts: state=> state.items[(DATA.ITEMS.STOCK_DRAFTS.values).toUpperCase()],
                JoinedStockDrafts: state=> state.join[(DATA.ITEMS.STOCK_DRAFTS.values).toUpperCase()], 
                QuotationsAndInvoices: state=> state.items[(DATA.ITEMS.QUOTATIONS_AND_INVOICES.values).toUpperCase()],
                JoinedQuotationsAndInvoices: state=> state.join[(DATA.ITEMS.QUOTATIONS_AND_INVOICES.values).toUpperCase()],
            }), 
            StockOutletsData(){ 
                const StockOutlets = this.StockOutlets 
                const JoinedStockOutlets = this.JoinedStockOutlets
                const items = JoinedStockOutlets?JoinedStockOutlets:StockOutlets  
                return items
            },
            StockOrdersData(){ 
                const StockOrders = this.StockOrders 
                const JoinedStockOrders = this.JoinedStockOrders
                const items = JoinedStockOrders?JoinedStockOrders:StockOrders 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false)) 
                console.log(StockOrders,'.........StockOrdersData');
                return list
            }, 
            OldStockOrdersData(){ 
                const OldStockOrders = this.OldStockOrders 
                const JoinedOldStockOrders = this.JoinedOldStockOrders
                const items = JoinedOldStockOrders?JoinedOldStockOrders:OldStockOrders 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false)) 
                console.log(OldStockOrders,'.........OldStockOrders');
                return list
            }, 
            StockRequestsData(){ 
                const StockRequests = this.StockRequests 
                const JoinedStockRequests = this.JoinedStockRequests
                const items = JoinedStockRequests?JoinedStockRequests:StockRequests 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false))  
                return list
            }, 
            StockDraftsData(){ 
                const StockDrafts = this.StockDrafts 
                const JoinedStockDrafts = this.JoinedStockDrafts
                const items = JoinedStockDrafts?JoinedStockDrafts:StockDrafts 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false))  
                return list
            }, 
            InvoiceData(){ 
                const data = this.QuotationsAndInvoices 
                const joinedData = this.JoinedQuotationsAndInvoices
                const items = joinedData?joinedData:data 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false)) 
                console.log(data,'.........InvoiceData');
                return list
            }, 
            AllStockOrders(){
                const StockOrdersData = this.StockOrdersData
                const InvoiceData = this.InvoiceData
                let items = []
                if (StockOrdersData) {
                    items.push(...StockOrdersData)
                }
                if (InvoiceData) {
                    items.push(...InvoiceData)
                }

                console.log(items,'items............');
                
                return items
            },
            TabData(){
                const tab = this.PAGE_CURRENT
                const orders = this.AllStockOrders
                const old_orders = this.OldStockOrdersData
                const request = this.StockRequestsData
                const drafts = this.StockDraftsData
                let data = orders
                if (tab ==1) {
                    data = request
                }if (tab ==2) {
                    data = drafts
                }if (tab ==3) {
                    data = old_orders
                }
                console.log(data,'=='+tab+"----------------------");
                
                return data


            },
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            },   
            /////////
            PageInfo(){
                return {}
                const page = this.PAGE_CURRENT
                let info = {
                    icon:"mdi-clipboard-check-multiple-outline",
                    title:"Complete Records"
                }
                if (page==1) {
                    info.title="Transactions Requests"
                }if (page==2) {
                    info.title="Saved Drafts"
                }
                return info
            },
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("stock",1,true) 
                return thisLinks
            }, 
            SOCK_ORDER_PATH(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_orders,true) 
                return path
            }, 

            PageTabs(){
                let  default_tab = [
                    {name:"COMPLETE",icon:"mdi-clipboard-check-multiple-outline",show_if:(this_,item)=>true, }, 
                    {name:"REQUESTS",icon:"mdi-clipboard-multiple-outline",show_if:(this_,item)=>true, },  
                    {name:"DRAFTS",icon:"mdi-clipboard-file-outline",show_if:(this_,item)=>true, }, 
                ]
                if (this.show_old_stock_order) {
                    default_tab.push({name:"OLD ORDERS",icon:"mdi-clipboard-text-clock-outline",show_if:(this_,item)=>true, }, )
                }

                return default_tab
            },
            TableTabs(){
                const page = this.PAGE_CURRENT
                const tab1 =[
                    {name:"Received",show_if:(this_,item)=>item.order_type==DATA.ITEMS.STOCK_RECEIVES.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }},
                    {name:"Transferred",show_if:(this_,item)=>item.order_type==DATA.ITEMS.STOCK_TRANSFERS.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }},
                    {name:"Returned",show_if:(this_,item)=>item.order_type==DATA.ITEMS.STOCKS_RETURN.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }},
                    {name:"Adjusted",show_if:(this_,item)=>item.order_type==DATA.ITEMS.STOCK_ADJUSTMENTS.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }}, 
                    {name:"Invoices",show_if:(this_,item)=>item.order_type==DATA.ITEMS.INVOICES.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }}, 
                ]
                const tab2 =[
                    {
                        name:"Requisitions",show_if:(this_,item)=>
                       (item.order_option=="save_requisition")&&!item.canceled&&!item.processed,
                        indicator:{
                            color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                        }
                    }, 
                    {
                        name:"Approval Requests",show_if:(this_,item)=>
                       (item.order_option=="send_for_approval")&&!item.canceled&&!item.processed,
                        indicator:{
                            color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                        }
                    }, 
                    {
                        name:"Verification Requests",show_if:(this_,item)=>
                        (item.order_option=="send_for_verification")&&!item.canceled&&!item.processed,
                        indicator:{
                            color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                        }
                    },
                    {
                        name:"Processed",show_if:(this_,item)=>
                        item.processed,
                        indicator:{
                            color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                        }
                    }, 
                    {
                        name:"Canceled",show_if:(this_,item)=>
                        item.canceled,
                        indicator:{
                            color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                        }
                    }, 
                ]
                const tab3 =[
                    {name:"All",show_if:(this_,item)=>true,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }},
                    {name:"Receive",show_if:(this_,item)=>item.order_type==DATA.ITEMS.STOCK_RECEIVES.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }},
                    {name:"Transfers",show_if:(this_,item)=>item.order_type==DATA.ITEMS.STOCK_TRANSFERS.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }},
                    {name:"Requisitions",show_if:(this_,item)=>item.order_type==DATA.ITEMS.STOCK_REQUISITIONS.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }},
                    {name:"Adjustments",show_if:(this_,item)=>item.order_type==DATA.ITEMS.STOCK_ADJUSTMENTS.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }}, 
                    {name:"Invoices",show_if:(this_,item)=>item.order_type==DATA.ITEMS.INVOICES.value,indicator:{
                        color:'primary',value:(this_,MBS,data)=>MBS.SIZE(data)
                    }}, 
                ]
                if (page==1) {
                    return tab2
                }if (page==2) {
                    return tab3
                }
                return tab1
            },
            TableActions(){
                const stockOrders = this.StockOrders
                const outlets = this.StockOutletsData
                let outlet_actions = []
                outlets.forEach(outlet => {
                    outlet_actions.push({
                        type:"btn",btn:true,
                        icon:outlet.icon,
                        color:"secondary", 
                        text:outlet.name+" Inventory",  
                        action:"inventory",
                        outlet_code:outlet.code
                    })
                    
                });
                let actions1 =[ 
                    // {type:"btn",btn:true,action:"order_stock",color:"secondary", outlined:false,  text:"Purchase Order"}, 
                    {type:"btn",btn:true,icon:"mdi-cog-transfer-outline",color:"secondary", text:"Stock Action", min_width:"",action:"stock_action",
                        actions:[
                            {type:"btn",btn:true,icon:mdiInvoiceTextPlusOutline,color:"secondary", text:"Stock Requisition", min_width:"",action:"stock_requisition"} , 
                            {type:"btn",btn:true,icon:"mdi-package-down",color:"secondary", text:"Receive Stock", min_width:"",action:"receive"} , 
                            {type:"btn",btn:true,icon:"mdi-transfer",color:"secondary", text:"Transfer Stock", min_width:"",action:"transfer"} , 
                            {type:"btn",btn:true,icon:mdiInvoiceCheck,color:"secondary", text:"Approve Stock", min_width:"",action:"approve_stock"} , 
                            {type:"btn",btn:true,icon:mdiInvoiceCheckOutline,color:"secondary", text:"Verify Stock", min_width:"",action:"verify_stock"} , 
                            {type:"btn",icon:"mdi-cog-transfer",color:"secondary",  text:"Adjust Stock",action:"adjust_stock"}, 
                        ]
                    } , 
                    {type:"btn",btn:true,icon:"mdi-file-table-box",color:"secondary", text:"Inventory", min_width:"",action:"stock_action",
                        actions:outlet_actions
                    } , 
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                    {type:"action",icon:"mdi-clipboard-text-clock-outline",action:"show_old_stock_orders",color:"secondary", outlined:false,  text:"Show Old Stock Orders"},  
                    
                ]
                
                
                let actions2 =[ 
                    // {type:"btn",btn:true,action:"order_stock",color:"secondary", outlined:false,  text:"Purchase Order"}, 
                    
                    {type:"btn",btn:true,icon:"mdi-package-down",color:"secondary", text:"Receive Stock", min_width:"",action:"receive"} , 
                    {type:"btn",btn:true,icon:"mdi-transfer",color:"secondary", text:"Transfer Stock", min_width:"",action:"transfer"} , 
                    {type:"btn",icon:"mdi-cog-transfer",color:"secondary",  text:"Adjust Stock",action:"adjust_stock"}, 
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                    
                ]
                return actions1

                if (this.MBS.actions.SIZE(stockOrders)>0) {
                    actions = [
                        ...actions,
                        {type:"btn",color:"secondary", text:"Return", min_width:"",action:"receive",
                        actions:[
                            {icon:"",action:"return_stock",text:"Return Received Stock"},
                            {icon:"",action:"return_sales",text:"Return Sales"}, 
                        ]} ,  
                        
                        // {type:"btn",action:"transfer_stock",color:"secondary",  text:"Transfer Stock"}, 
                        {type:"btn",action:"adjust_stock",color:"secondary",  text:"Adjust Stock"}, 
                    ]
                }else{
                    actions = [
                        {type:"btn",action:"opening_stock",color:"secondary", outlined:false,  text:"Opening Stock"}, 
                        ...actions
                    ]
                }
                return actions
            },
            HEADER_GENERAL(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon',color:"secondary",size:25,show:true},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"date",value:'created_at_',show:true},   
                    {id:0,name:"update date",value:'updated_at',show:false},   
                    {id:0,name:"Type",value:'type_name',show:true},   
                    {id:0,name:"code",align:"center",show:true},         
                    {id:0,name:"user",value:"user_name",show:false},     
                    {id:0,name:"From",value:"deliver_from_name",show:true},     
                    {id:0,name:"To",value:"deliver_to_name",show:true},     
                    {id:0,name:"Status",value:"status",show:false},     
                    {id:0,name:"items",value:'total_quantity_',align:'right',show:true},   
                    {id:0,name:"Payment",value:'payment_method_name',align:'right',show:true},   
                    {id:0,name:"Status",value:'payment_status',align:'right',show:true},   
                    {id:0,name:"Total Cost",value:'total_price_',align:'right',show:true},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Order",action:"view_order",icon:"mdi-eye"}, 
                        {name:"Archive Order",action:"archive_item",icon:"mdi-delete"},   
                    ]}, 
                ]
            },
            HEADER_REQUEST(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon',color:"secondary",size:25,show:true},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"date",value:'created_at_',show:true},   
                    {id:0,name:"update date",value:'updated_at',show:false},   
                    {id:0,name:"code",align:"center",show:true},         
                    {id:0,name:"user",value:"user_name",show:true},     
                    {id:0,name:"Type",value:'type_name',show:true},   
                    {id:0,name:"From",value:"deliver_from_name",show:true},     
                    {id:0,name:"To",value:"deliver_to_name",show:true},     
                    {id:0,name:"Status",value:"status",show:false},     
                    {id:0,name:"items",value:'total_quantity_',align:'right',show:true},   
                    {id:0,name:"Payment",value:'payment_method_name',align:'right',show:false},   
                    {id:0,name:"Status",value:'payment_status',align:'right',show:false},   
                    {id:0,name:"Total Cost",value:'total_price_',align:'right',show:true},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Request",action:"view_order",icon:"mdi-file-eye"}, 
                        {name:"Approve Request",action:"approve_request",icon:mdiInvoiceCheck,
                            show_if:item=>item.order_option=="send_for_approval"&&!item.processed&&!item.canceled}, 
                        {name:"Verify Request",action:"verify_request",icon:mdiInvoiceCheckOutline,
                            show_if:item=>item.order_option=="send_for_verification"&&!item.processed&&!item.canceled}, 
                        {name:"Receive stock based on requisition",action:"receive_stock_based_on_requisition",icon:"mdi-clipboard-arrow-down-outline",
                            show_if:item=>item.order_option=="save_requisition"&&!item.processed&&!item.canceled}, 
                        {name:"Mark requisition as processed",action:"mark_requisition_as_processed",icon:"mdi-file-check-outline",
                            show_if:item=>item.order_option=="save_requisition"&&!item.processed&&!item.canceled}, 
                        {name:"Cancel Request",action:"cancel_request",icon:"mdi-delete",
                            show_if:item=>!item.processed&&!item.canceled}, 
                    ]}, 
                ]
            },
            HEADER_OLD_STOCK(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon',color:"secondary",size:25,show:true},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"date",value:'created_at_',show:true},   
                    {id:0,name:"update date",value:'updated_at',show:false},   
                    {id:0,name:"Type",value:'type_name',show:true},   
                    {id:0,name:"code",align:"center",show:true},         
                    {id:0,name:"user",value:"user_name",show:false},     
                    {id:0,name:"From",value:"deliver_from_name",show:true},     
                    {id:0,name:"To",value:"deliver_to_name",show:true},     
                    {id:0,name:"Status",value:"status",show:false},     
                    {id:0,name:"items",value:'total_quantity_',align:'right',show:true},   
                    {id:0,name:"Payment",value:'payment_method_name',align:'right',show:true},   
                    {id:0,name:"Status",value:'converted_to_new_version',align:'right',show:true},   
                    {id:0,name:"Total Cost",value:'total_price_',align:'right',show:true},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Order",action:"view_order",icon:"mdi-eye"}, 
                        {name:"Convert to new Version",action:"convert_old_version",icon:"mdi-eye",show_if:item=>!item.converted_to_new_version}, 
                        {name:"Archive Order",action:"archive_item",icon:"mdi-delete"},   
                    ]}, 
                ]
            },
            HEADER_ITEMS(){
               const page = this.PAGE_CURRENT
                const general = this.HEADER_GENERAL
                const request = this.HEADER_REQUEST
                let header = general
                if (page == 1) {
                    header = request
                }if (page == 3) {
                    header = this.HEADER_OLD_STOCK
                }
                return  header
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:true},  
                    {id:0,name:"name",show:true}, 
                    {id:0,name:"code",align:"center",show:true},      
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },    
        },
        methods: { 
            TABLE_ACTION(action,item){
                try { 
                    console.log(action,item);
                    
                    if (action == "opening_stock") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/opening-stock",true))
                    }else if (action == "order_stock") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/order-stock",true))
                    }else if (action == "receive_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/receive-stock",true))
                    }else if (action == "receive_invoice") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/quotations&invoices/receive-invoice",true))
                    }else if (action == "receive_quotation") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/quotations&invoices/receive-quotation",true))
                    }else if (action == "receive_stock_with_invoice") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/receive-stock-with-invoice",true))
                    }else if (action == "return_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/return-stock",true))
                    }else if (action == "transfer_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/transfer-stock",true))
                    }else if (action == "adjust_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/adjust-stock",true))
                    }else if (action == "return_sales") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/sales-return",true))
                    }else if (action == "inventory") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/manage/"+item?.outlet_code,true))
                    }else if (action == "stock_requisition") { 
                        this.STOCK_REQUISITION(item.key) 
                    }else if (action == "receive") { 
                        this.RECEIVE_STOCK(item.key) 
                    }else if (action == "transfer") { 
                        this.TRANSFER_STOCK(item.key) 
                    }else if (action == "approve_stock") { 
                        this.ON_APPROVE_STOCK(item) 
                    }else if (action == "verify_stock") { 
                        this.ON_VERIFY_STOCK(item) 
                    }else if (action == "show_old_stock_orders") { 
                        this.ON_SHOW_OLD_STOCK_ORDERS(item) 
                    }  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ITEM_ACTION(action,item){
                try { 
                    let link = "/stock/stock-control/"+(item?item.key:null)
                    const path = this.MBS.actions.COMPANY_LINK(link,true)  
                    if (action == "view_order") {
                        this.MBS.actions.go(path)
                    }else if (action == "approve_request") { 
                        this.APPROVE_STOCK({request_order:item}) 
                    }else if (action == "verify_request") { 
                        this.VERIFY_STOCK({request_order:item}) 
                    }else if (action == "receive_stock_based_on_requisition") { 
                        this.ON_RECEIVE_STOCK_BASE_ON_REQUISITION({request_order:item}) 
                    }else if (action == "mark_requisition_as_processed") { 
                        this.ON_MARK_REQUISITION_AS_PROCESSED({request_order:item}) 
                    }else if (action == "cancel_request") { 
                        this.VERIFY_STOCK({request_order:item,cancel:true}) 
                    }else if (action == "convert_old_version") { 
                        console.log(item,'..................');
                        this.ON_CONVERT_OLD_VERSION(item)
                        
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            TRANSFER_STOCK(item_key, item_code){
                try {  
                    console.log(item_key,item_code,);
                     this.MBS.events.$emit("INVENTORY_STOCK_TRANSFER",{
                        item_key:item_key,
                        item_code:item_code,   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            RECEIVE_STOCK(item_key, item_code){
                try {  
                    console.log(item_key,item_code,);
                     this.MBS.events.$emit("INVENTORY_STOCK_RECEIVE",{
                        item_key:item_key,
                        item_code:item_code,   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            STOCK_REQUISITION(item_key, item_code){
                try {   
                    this.MBS.events.$emit("INVENTORY_STOCK_REQUISITION",{
                        item_key:item_key,
                        item_code:item_code,   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            ON_APPROVE_STOCK(item_key, item_code){
                try {  
                    let mbs_text = this.MBS.text.item_action("Stock","Approve")
                    this.MBS.actions.dialog({
                        show:true,
                        icon:mdiInvoiceCheck,
                        title:mbs_text.title,
                            text:mbs_text.text+' Click "Received Stock" to approve incoming stock or "Transferred Stock" Button bellow to approve transferring. To cancel click X button above.',
                        btnYes:"Received Stock",
                        btnNo:"Transferred Stock",
                        action:{
                            code:PAGE_NAME+"=APPROVE-STOCK", 
                            silent_btn_no:true
                        }
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_APPROVE_STOCK',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            ON_VERIFY_STOCK(item_key, item_code){
                try {  
                    let mbs_text = this.MBS.text.item_action("Stock","Verify")
                    this.MBS.actions.dialog({
                        show:true,
                        icon:mdiInvoiceCheck,
                        title:mbs_text.title,
                            text:mbs_text.text+' Click "Received Stock" to verify incoming stock or "Transferred Stock" Button bellow to verify transferring. To cancel click X button above.',
                            btnNo:"Received Stock",
                        btnYes:"Transferred Stock",
                        action:{
                            code:PAGE_NAME+"=VERIFY-STOCK", 
                            silent_btn_no:true
                        }
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_VERIFY_STOCK',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            ON_RECEIVE_STOCK_BASE_ON_REQUISITION(payload){
                try {  
                    const request_order = payload?.request_order
                    let mbs_text = this.MBS.text.item_action("Stock base on requisition","Receive")
                    this.MBS.actions.dialog({
                        show:true,
                        icon:"mdi-clipboard-arrow-down-outline",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnNo:mbs_text.btnNo,
                        btnYes:mbs_text.btnYes,
                        action:{
                            code:PAGE_NAME+"=RECEIVE-STOCK-BASE-ON-REQUISITION",
                            payload
                        }
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_RECEIVE_STOCK_BASE_ON_REQUISITION',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            ON_MARK_REQUISITION_AS_PROCESSED(item_key, item_code){
                try {  
                    let mbs_text = this.MBS.text.item_action("As processed","Mark Requisition")
                    this.MBS.actions.dialog({
                        show:true,
                        icon:"mdi-file-check-outline",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnNo:mbs_text.btnNo,
                        btnYes:mbs_text.btnYes,
                        action:{
                            code:PAGE_NAME+"=MARK-REQUISITION-AS-PROCESSED",  
                        }
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_MARK_REQUISITION_AS_PROCESSED',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            APPROVE_STOCK(payload){
                try {  
                    const request_order = payload?.request_order 
                    const receive =request_order?.order_type=="stock_receive"?true:payload?.receive
                    this.MBS.events.$emit(receive?"INVENTORY_STOCK_RECEIVE":"INVENTORY_STOCK_TRANSFER",{
                        ...payload,
                        approve:true,
                        step:2   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'APPROVE_STOCK',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            VERIFY_STOCK(payload){
                try {  
                    const request_order = payload?.request_order 
                    const receive =request_order?.order_type=="stock_receive"?true:payload?.receive
                    this.MBS.events.$emit(receive?"INVENTORY_STOCK_RECEIVE":"INVENTORY_STOCK_TRANSFER",{
                        ...payload, 
                        verify:true,
                        step:2   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'VERIFY_STOCK',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            RECEIVE_STOCK_BASE_ON_REQUISITION(payload){
                try { 
                    this.MBS.events.$emit("INVENTORY_STOCK_RECEIVE",{
                        ...payload, 
                        receive_stock_based_requisition:true,
                        step:2   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'RECEIVE_STOCK_BASE_ON_REQUISITION',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            MARK_REQUISITION_AS_PROCESSED(payload){
                try { 
                    this.MBS.events.$emit("INVENTORY_STOCK_RECEIVE",{
                        ...payload, 
                        mark_as_processed:true,
                        step:2   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'MARK_REQUISITION_AS_PROCESSED',
                        page:PAGE_NAME, 
                    }) 
                }
            },

            ON_SHOW_OLD_STOCK_ORDERS(){
                try {  
                    // this.PAGE_CURRENT = null
                    // setTimeout(() => {
                        
                    //     this.PAGE_CURRENT = 2
                    // }, 500);
                    // return
                    let mbs_text = this.MBS.text.item_action("Old Stock Orders","View")
                    this.MBS.actions.dialogConfirmPassword({
                        show:true,
                        icon:"mdi-clipboard-text-clock-outline",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=SHOW-OLD-STOCK-ORDERS', 
                            phone_number_start:true,
                            all_users:true,
                            get_access:{
                                permission_type:"action", 
                                permission_to:"write", 
                                action_name:DATA.ITEMS.ITEMS.names
                            }
                        }
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_SHOW_OLD_STOCK_ORDERS',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            SHOW_OLD_STOCK_ORDERS(){
                try {  
                    this.show_old_stock_order = true
                    this.PAGE_CURRENT = null
                    setTimeout(() => {
                        this.PAGE_CURRENT = 3 
                    }, 500);
                    this.$store.dispatch("fi_get_old_stock_orders",{
                        path:this.MBS.actions.COMPANY_LINK(DATA.PATHS.old_stock_orders,true),
                        on:true,
                        get:false
                    }).then(res=>{
                        this.downloading = false
                        console.log(res,'res....FI_INITIATE.....');
                    }).catch(error=>{
                        this.downloading = false
                        console.log(error,'error.....FI_INITIATE.......');
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SHOW_OLD_STOCK_ORDERS',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            
            ON_CONVERT_OLD_VERSION(order){
                try {  
                    const order_key = order?.key
                    const orders = this.OldStockOrders
                    const data = orders?.find(o=>o.key == order_key)
                    let mbs_text = this.MBS.text.item_action("Old Version","Convert")
                    this.MBS.actions.dialog({
                        show:true, 
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=CONVERT-OLD-VERSION', 
                            data,
                            phone_number_start:true,
                            all_users:true,
                            get_access:{
                                permission_type:"action", 
                                permission_to:"write", 
                                action_name:DATA.ITEMS.ITEMS.names
                            }
                        }
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_CONVERT_OLD_VERSION',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            CONVERT_OLD_VERSION(order){
                try {  
                    console.log(order);
                    this.inputLoading = true
                    const order_key = order?.key
                    const path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_orders+order_key,true)
                    const old_path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.old_stock_orders+order_key,true)
                    this.MBS.actions.progressDialog({
                        show:true,
                        title:"Uploading..",
                    }) 
                    this.$store.dispatch("fi_update",{
                        action:DATA.ITEMS.STOCK_ORDERS.values,
                        data:{...order,from_old:true},
                        path:path
                    })
                    .then(res=>{
                        console.log(res,'re..................'); 
                        return this.$store.dispatch("fi_update",{
                            action:DATA.ITEMS.STOCK_ORDERS.values,
                            data:{converted_to_new_version:true},
                            path:old_path
                        })
                    })
                    .then(res=>{
                        this.inputLoading = false 
                        this.MBS.actions.progressDialog()  
                        let mbs_text = this.MBS.text.item_action_success("Old Version","Converting")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes, 
                        })   
                        console.log(res,'re2..................s');
                            
                    }).catch(error=>{
                        console.log(error,'err..................');
                        this.MBS.actions.progressDialog()  
                        this.inputLoading = false 
                        let mbs_text = this.MBS.text.item_action_fail("Old Version","Converting")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes, 
                        })  
                    }) 
                      
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONVERT_OLD_VERSION',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
             
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=ADD-ITEM') {
                            if (action.YES) {
                                if (this.input.check) { 
                                    this.input.check = false 
                                    setTimeout(() => {
                                        this.input.loading = true 
                                        this.$store.dispatch("fi_add",{
                                            action:this.VALUE_ITEM,
                                            path:this.PATH_ITEM,
                                            data:action.data,
                                            us:this.us
                                        })
                                    }, ACTION_TIME);  
                                }   
                            } else {
                                
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=APPROVE-STOCK') {
                            if (action.YES) {
                                this.APPROVE_STOCK ({receive:true})
                            } else {
                                this.APPROVE_STOCK () 
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=VERIFY-STOCK') {
                            if (action.YES) {
                                this.VERIFY_STOCK ({receive:true})
                            } else {
                                this.VERIFY_STOCK () 
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=RECEIVE-STOCK-BASE-ON-REQUISITION') {
                            if (action.YES) {
                                this.RECEIVE_STOCK_BASE_ON_REQUISITION (action.payload)
                            } else { 
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=MARK-REQUISITION-AS-PROCESSED') {
                            if (action.YES) {
                                this.MARK_REQUISITION_AS_PROCESSED ()
                            } else { 
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=SHOW-OLD-STOCK-ORDERS') {
                            if (action.YES) {
                                this.SHOW_OLD_STOCK_ORDERS ()
                            } else { 
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=CONVERT-OLD-VERSION') {
                            if (action.YES) {
                                this.CONVERT_OLD_VERSION (action.data)
                            } else { 
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            }) 
                             
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            }, 
        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);        
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch: { 
            us:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            loading:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            processes:{ 
                handler:"FEEDBACKS",
                immediate:true
            },
            responses:{ 
                handler:"FEEDBACKS",
                immediate:true
            } 
        },
    }
</script>
 
